import type { DataTableColumn } from "./types";

type TableHeaderProps = {
  columns: DataTableColumn[];
};

const TableHeader = ({ columns }: TableHeaderProps) => {
  return (
    <thead className="bg-myteengig-background">
      <tr>
        {columns.map((column) => (
          <th
            key={column.key}
            className={column.className ?? "px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide text-myteengig-text-muted"}
          >
            {column.label}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
